import PropTypes from 'prop-types'
import React from 'react'
import { isSuccessful } from '../../../hooks/useQuery'
import useOfficeHourDetail from '../../../hooks/feature/office_hours/useOfficeHourDetail'
import OfficeHourCard from './OfficeHourCard'

const baseMessage = 'El horario de atención de la Mesa de partes'
const receptionDeskAdditionalConfigOptions = {
  required: (
    <>
      {baseMessage} será <span className="font-bold">obligatorio y fijo</span> para todos los formularios creados con la
      plantilla Mesa de partes.
    </>
  ),
  suggested_required: (
    <>
      {baseMessage} será sugerido durante el proceso de creación de los formularios creados con la plantilla Mesa de
      partes.
      <br />
      El creador del formulario puede editar el horario o mantener el sugerido.
    </>
  )
}

const otherBaseMessage = 'El horario de atención definido'
const otherAdditionalConfigOptions = {
  required: (
    <>
      {otherBaseMessage} será <span className="font-bold">obligatorio y fijo</span> para todos los formularios de la
      entidad.
    </>
  ),
  suggested_required: (
    <>
      {otherBaseMessage} será sugerido durante el proceso de creación de los formularios de la entidad.
      <br />
      El creador del formulario puede editar el horario o mantener el sugerido, pero este será un campo obligatorio.
    </>
  ),
  suggested: (
    <>
      {otherBaseMessage} será sugerido durante el proceso de creación de los formularios de la entidad.
      <br />
      El creador del formulario puede editar el horario o mantener el sugerido, pero este no será un campo obligatorio.
    </>
  )
}

const OfficeHoursViewer = ({ institutionId }) => {
  const {
    status,
    receptionDeskEndOfficeHour,
    receptionDeskStartOfficeHour,
    otherFormsEndOfficeHour,
    otherFormsStartOfficeHour,
    otherHoursShowWarning,
    receptionDeskTotalHours,
    otherTotalHours,
    otherFormsEnabled,
    receptionDeskAdditionalConfig,
    otherFormsAdditionalConfig
  } = useOfficeHourDetail(institutionId)

  if (!isSuccessful(status)) return null

  const buildOfficeHourData = ({ startOfficeHour, endOfficeHour, totalHours, totalHoursWarning, additionalConfig }) => [
    { title: 'Hora de inicio de atención:', value: startOfficeHour },
    { title: 'Hora de fin de atención:', value: endOfficeHour },
    { title: 'Total de horas:', value: totalHours, valueWarning: totalHoursWarning },
    { title: 'Configuración adicional', value: additionalConfig }
  ]

  const receptionDesk = buildOfficeHourData({
    startOfficeHour: receptionDeskStartOfficeHour,
    endOfficeHour: receptionDeskEndOfficeHour,
    totalHours: receptionDeskTotalHours,
    additionalConfig: receptionDeskAdditionalConfigOptions[receptionDeskAdditionalConfig]
  })

  const otherForms = buildOfficeHourData({
    startOfficeHour: otherFormsStartOfficeHour,
    endOfficeHour: otherFormsEndOfficeHour,
    totalHours: otherTotalHours,
    totalHoursWarning: otherHoursShowWarning,
    additionalConfig: otherFormsEnabled ? otherAdditionalConfigOptions[otherFormsAdditionalConfig] : '-'
  })

  return (
    <div className="p-10 mb-16 bg-neutral-100 rounded">
      <h2 className="mb-6 text-xl font-bold">Horarios de atención de la entidad</h2>
      <div className="flex flex-col md:flex-row gap-6 w-full">
        <OfficeHourCard
          title="Horario de atención de la Mesa de partes"
          status="Obligatorio"
          items={receptionDesk}
          key="reception-desk-forms"
        />
        <OfficeHourCard
          title="Horario de atención de otros formularios"
          status={otherFormsEnabled ? 'Habilitado' : 'Deshabilitado'}
          items={otherForms}
          key="other-forms"
        />
      </div>
    </div>
  )
}

export default OfficeHoursViewer

OfficeHoursViewer.propTypes = {
  institutionId: PropTypes.number
}
